<template>
  <div class="Investment-box" style="width: 100% !important;">
    <div class="head-text">
      <h1>{{category_name}}</h1>
    </div>
    <div class="card-box">
      <h4>Select your option</h4>
      <v-row>
      	<template>
          <v-card
          	v-for="subcategory_item in subcategory_items_list.items"

          	:key="subcategory_item.name"
            class="mx-auto"
            outlined
            @click="subCategoryDetail()"
          > 

             <v-list-item three-line>
              <v-list-item-content>
                <div class="overline">
                	<v-img
        			max-height="39"
        			max-width="39"
        			:src="webIcon + subcategory_item.icon"
                	>
                	</v-img>
                </div>

                <v-list-item-title>{{subcategory_item.name}}</v-list-item-title>
              </v-list-item-content>
              <v-btn @click="subCategoryDetail()" text> 
                <v-img
                  max-height="30" 
                  max-width="30"
                  src="https://dev-api.nimeya.ai/img/icons/forword_arrow.png"
                >
                </v-img>
              </v-btn>
            </v-list-item>
          </v-card>
        </template>
      </v-row>
    </div>
  </div>
</template>

<script>
import { GET_KEEP_SUB_SAFE_CATEGORY_DATA } from "../../store/actions.type";

import { isEmpty } from 'lodash';
   export default {
      data: () => ({
       	category:'',
       	webIcon:process.env.VUE_APP_ROOT_ICONS_URL,
       	subcategory_items_list:[],
       	response_data:'',
       	category_name:''
      }),
      mounted (){
        Fire.$on("subCategoryData", () => {
          this.subCategoryData();
        });
        if (isEmpty(this.$store.getters.getKeepSafeSubCategoryData)) {
          this.subCategoryData();
        }
        else {
          this.response_data = this.$store.getters.getKeepSafeSubCategoryData.data;
          this.subcategory_items_list = this.response_data.items;
        }
        this.category_name = this.$route.params.category_name;
      },
      methods: {
        subCategoryData(){
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            this.$store.dispatch(GET_KEEP_SUB_SAFE_CATEGORY_DATA, {
            data: {
	            aws_cognito_id:cognito_idp,
	            category:this.$route.params.category,
            },
            api: 'get-keep-safe-subcategory',
          })
          .then(() => {
	            this.response_data = this.$store.getters.getKeepSafeSubCategoryData.data;
	            this.subcategory_items_list = this.response_data.items;

          });
        },

        subCategoryDetail(i, a){

        }
    }
} 
</script>